import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Suite from './Suite';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suite />
  </React.StrictMode>
);
